import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-64d31ece")

_pushScopeId("data-v-64d31ece")
const _hoisted_1 = { class: "kn-page" }
const _hoisted_2 = { class: "kn-page-content p-grid p-m-0" }
const _hoisted_3 = { class: "p-col-4 p-sm-4 p-md-3 p-p-0 kn-page" }
const _hoisted_4 = { class: "p-col-8 p-sm-8 p-md-9 p-p-0 p-m-0 kn-router-view" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_FabButton = _resolveComponent("FabButton")
  const _component_Menu = _resolveComponent("Menu")
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_KnInputFile = _resolveComponent("KnInputFile")
  const _component_ProgressBar = _resolveComponent("ProgressBar")
  const _component_KnListBox = _resolveComponent("KnListBox")
  const _component_router_view = _resolveComponent("router-view")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--primary" }, {
          start: _withId(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('managers.widgetGallery.title')), 1)
          ]),
          end: _withId(() => [
            _createVNode(_component_FabButton, {
              icon: "fas fa-plus",
              onClick: _ctx.toggleAdd
            }, null, 8, ["onClick"]),
            _createVNode(_component_Menu, {
              ref: "menu",
              model: _ctx.addMenuItems,
              popup: "true"
            }, null, 8, ["model"])
          ]),
          _: 1
        }),
        _createVNode(_component_KnInputFile, {
          label: "",
          "change-function": _ctx.uploadTemplate,
          accept: "application/json,application/zip",
          "trigger-input": _ctx.triggerInput
        }, null, 8, ["change-function", "trigger-input"]),
        (_ctx.loading)
          ? (_openBlock(), _createBlock(_component_ProgressBar, {
              key: 0,
              mode: "indeterminate",
              class: "kn-progress-bar"
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_KnListBox, {
          options: _ctx.galleryTemplates,
          settings: _ctx.typeDescriptor.knListSettings,
          onDelete: _cache[1] || (_cache[1] = ($event: any) => (_ctx.deleteTemplate($event, _ctx.item)))
        }, null, 8, ["options", "settings"])
      ]),
      _createVNode("div", _hoisted_4, [
        _createVNode(_component_router_view, { onSaved: _ctx.savedElement }, null, 8, ["onSaved"])
      ])
    ])
  ]))
})